import { render, staticRenderFns } from "./ConfirmSenior.vue?vue&type=template&id=3023c75a&scoped=true"
import script from "./ConfirmSenior.vue?vue&type=script&lang=js"
export * from "./ConfirmSenior.vue?vue&type=script&lang=js"
import style0 from "./ConfirmSenior.vue?vue&type=style&index=0&id=3023c75a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3023c75a",
  null
  
)

export default component.exports